import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import EstatePlanningProfileSubpageStepAction from './EstatePlanningProfileSubpageStepAction/EstatePlanningProfileSubpageStepAction';


const EstatePlanningProfileSubpageStepActionPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.primaryAction.name]: (<EstatePlanningProfileSubpageStepAction relationship={resource?.relationship(fr.relationships.primaryAction.name)} />),
  }, null);
};

EstatePlanningProfileSubpageStepActionPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
EstatePlanningProfileSubpageStepActionPicker.defaultProps = {};

export default EstatePlanningProfileSubpageStepActionPicker;
